module.exports = __webpack_public_path__ + "6832065f8cf4332301870f0f3163a444.ttf";